import * as React from 'react';
import { Mutation } from 'react-apollo';
import { ApolloError } from 'apollo-client';

import DEVICES_QUERY from 'settings/queries/devicesQuery.gql';
import REMOVE_DEVICE_FROM_USER_MUTATION from 'settings/queries/RemoveDeviceFromUserMutation.gql';
import ToastActions from 'actions/ToastActions';

import { RemoveDeviceFromUserVariables } from 'settings/queries/__generated__/RemoveDeviceFromUser';

type Props = {
  children: (
    removeDevice: (input: { variables: RemoveDeviceFromUserVariables }) => void
  ) => React.ReactElement;
  deviceName: string;
};

export default function RemoveDeviceFromUserMutationContainer(props: Props) {
  return (
    <Mutation
      mutation={REMOVE_DEVICE_FROM_USER_MUTATION}
      refetchQueries={() => [{ query: DEVICES_QUERY }]}
      onCompleted={() =>
        ToastActions.showSuccessToast(`${props.deviceName} was successfully removed`)
      }
      onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}>
      {props.children}
    </Mutation>
  );
}
